export default __webpack_public_path__ + "static/media/honeycomb.51eab055.png";